import React, { useEffect } from 'react';

interface AppSecurityWrapperProps {
  children: React.ReactNode;
}

export const AppSecurityWrapper = ({ children }: AppSecurityWrapperProps) => {
  // Completely simplified - no security features active
  return <>{children}</>;
};